export default __webpack_public_path__ + "static/media/Group502-tata-neu@2x.d4407a26.png";